export const BRAND = 'BRAND'
export const CUSTOMER = 'CUSTOMER'
export const LAYBY = 'LAYBY'
export const NEUTRAL = 'NEUTRAL'
export const NOTIFY = 'NOTIFY'
export const SUCCESS = 'SUCCESS'
export const WARNING = 'WARNING'
